import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  license_plate_tab: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, TrackingConstant.TAB_SELECT),
  vin_tab: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, TrackingConstant.TAB_SELECT),
  add_photos: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, TrackingConstant.SUBACTION_ADD_PHOTOS),
  read_photo_guidelines: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, 'read-photo-guidelines'),
  submit_listing: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBMIT_LISTING_FOR_APPROVAL_ATTEMPTED
  ),
  buy_full_history_report: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WEBSITE_CLICKOUT,
    TrackingConstant.EXPERIAN_PAID_VHR
  ),
  see_recall_info: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WEBSITE_CLICKOUT,
    TrackingConstant.SEE_RECALL_INFO
  ),
  view_share_options: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SHARE_OPTIONS
  ),
  view_fsbo_guidelines: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'view_fsbo_guidelines'),
  try_again: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, TrackingConstant.PREVIEW_ERROR_TRY_AGAIN),
  go_back: TrackingEvent.actionProgress(TrackingConstant.ACTION_FILL_FORM, TrackingConstant.PREVIEW_ERROR_GO_BACK),
  block_sender_attempt: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBMIT_BLOCK_SENDER_ATTEMPT
  ),
  submit_block_sender: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBMIT_BLOCK_SENDER_SUCCESS
  ),
  report_sender_attempt: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBMIT_REPORT_SENDER_ATTEMPT
  ),
  submit_report_sender: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBMIT_REPORT_SENDER_SUCCESS
  ),
};

export const PrivateListingMap = {
  ...CommonMap,
  ...map,
};
